

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/UM150A.png";
import thumb1 from "../assets/images/New-Products/rootIn.jpg";
import thumb2 from "../assets/images/All-Products/UM150A.png";
import thumb3 from "../assets/images/All-Products/rootINF.png";
import howToUseThumb from "../assets/images/medical-bredcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/medical-bredcrum.jpg";
import indication1 from "../assets/images/icons/Gynecology.png";
import indication2 from "../assets/images/icons/Otorhinolaryngology.png";
import indication3 from "../assets/images/icons/Urology.png";
import indication4 from "../assets/images/icons/Neurosurgery.png";
import indication5 from "../assets/images/icons/Surgery.png";
import indication6 from "../assets/images/icons/Internal-Medicine.png";
import indication7 from "../assets/images/icons/Dermatology.png";
import indication8 from "../assets/images/icons/Plastic-Surgery.png";
import indication9 from "../assets/images/icons/Ophthalmology.png";
import indication10 from "../assets/images/icons/Surgery.png";
import indication11 from "../assets/images/icons/Orthopedics.png";
import indication12 from "../assets/images/icons/Family-Medicine.png";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("product_highlights");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Engineering the Future of Medical Precision"
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Medical Engineering", to: "/MedicalEnggProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>UM150A</h2>
              <p className="sub-heading">Radio frequency surgical unit</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>This unit is optimized with a special purpose to perform LOOP electrosurgical excision and coagulation procedures.</li>
                  <li>Cleaner, faster, and more precise excision.</li>
                  <li>This unit provides maximum convenience.</li>
                  <li>User-friendly and safety-oriented design.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">UM150A</span>
                </h3>
                <p>
                  UM-150A is a high-frequency radiofrequency electrosurgical device used for precise
                  cutting and coagulation procedures
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["product_highlights", "indications", "technical_specifications"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "product_highlights"
                    ? "Product Highlights"
                    : tab === "indications"
                      ? "Indications"
                      : tab === "technical_specifications"
                        ? "Technical Specifications"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "product_highlights" && (
                <div className="tab-content fade-in">
                  <p><strong> Product Highlights</strong></p>
                  <ul>
                    <li>This unit adopts 4.8 MHz Radio Frequency to achieve optimal surgical results.</li>
                    <li>Any size and shape of electrodes are available.</li>
                    <li>Autoclavable titanium bipolar forceps minimize tissue damage.</li>
                    <li>Equipped with automatic visual and audible monitoring and warning system; the power output is automatically cut off in any interruption.</li>
                    <li>For safety, cutting power and coagulating power do not work at the same time.</li>
                    <li>EMI filter included.</li>
                    <li>When using the bipolar generator, no more power than necessary is generated, minimizing the danger of faulty dosage.</li>
                    <li>Blend modes are designated as low and high.</li>
                    <li>High-frequency power is generated at the active electrode only, preventing inadvertent burns or damage.</li>
                  </ul>



                </div>
              )}
              {activeTab === "indications" && (
                <div className="tab-content fade-in">
                  <div className="indications-grid">

                    <div className="indication-item">
                      <img src={indication1} alt="Gynecology" />
                      <p>Gynecology</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication2} alt="Otorhinolaryngology" />
                      <p>Otorhinolaryngology</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication3} alt="Urology" />
                      <p>Urology</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication4} alt="Neurosurgery" />
                      <p>Neurosurgery</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication5} alt="Surgery" />
                      <p>Surgery</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication6} alt="Internal Medicine" />
                      <p>Internal Medicine</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication7} alt="Dermatology" />
                      <p>Dermatology</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication8} alt="Plastic Surgery" />
                      <p>Plastic Surgery</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication9} alt="Ophthalmology" />
                      <p>Ophthalmology</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication10} alt="Surgical Operation" />
                      <p>Surgical Operation</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication11} alt="Orthopedics" />
                      <p>Orthopedics</p>
                    </div>

                    <div className="indication-item">
                      <img src={indication12} alt="Family Medicine" />
                      <p>Family Medicine</p>
                    </div>

                  </div>
                </div>
              )}

              {activeTab === "technical_specifications" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Input Power:</strong> 110V/220V, 50Hz/60Hz</li>
                      <li><strong>Weight:</strong> 13 kg</li>
                      <li><strong>Dimension:</strong> 330(W) x 430(L) x 125(H) mm</li>
                      <li><strong>Operating Frequency:</strong> 4.8 MHz</li>
                    </ul>


                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
